import { WarningAmberRounded } from '@mui/icons-material';
import { Alert, AlertProps } from '@mui/material';

// TODO(jessica): Something's wonky with our font sizes and line heights, investigate later.
// We may want to apply this adjustment to all of our alerts, but I didn't have time during
// shift block request work to review the usages to be sure.
export const alertFontStyles = { fontSize: '14px', lineHeight: '1.43' };

export const AxleAlert = (props: AlertProps) => {
    return (
        <Alert
            iconMapping={{ warning: <WarningAmberRounded /> }}
            sx={{ display: 'flex', alignItems: 'center' }}
            {...props}
        >
            {props.children}
        </Alert>
    );
};
